import { Order } from 'entities/orders/model/types';
import { FC, useEffect, useMemo, useState } from 'react';
import { ConfirmOrderButton, ConfirmOrderButtonWrapper, TColorText } from './styles';

import checkIcon from 'assets/icons/small-check-icon.svg';
import checkWhiteIcon from 'assets/icons/small-check-icon-white.svg';
import closeWhiteIcon from 'assets/icons/small-close-white-icon.svg';
import { Img } from 'shared/ui/imgStyledComponent';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { editOrderConfirmed } from 'entities/orders/model/ordersThunk';
import { selectOrderDetail, selectOrderForBooking } from 'entities/orders/model/selectors';
import { updateOrderDetail } from 'entities/orders/model/ordersSlice';
import { useOrderState } from 'entities/orders/lib/hooks/order/useOrderState';

type OrderConfirmProps = { 
  order: Order; 
  mode?: 'default' | 'small' | 'medium', 
  callback?: (id: number, status?: boolean | null) => void 
}
export const OrderConfirm: FC<OrderConfirmProps> = ({ 
  order, 
  mode = 'default', 
  callback 
}) => {

	const dispatch = useAppDispatch();
	const [confirmedStatus, setConfirmedStatus] = useState<boolean | null | undefined>(undefined);
	const orderDetails = useAppSelector(selectOrderDetail);
	const orderBooking = useAppSelector(selectOrderForBooking);
	const { isVisitEnd } = useOrderState(order);

	const variant = useMemo(() => {
		if (confirmedStatus === undefined) {
			if (order.is_confirmed === null) {
				return 'outlined';
			}

			if (order.is_confirmed === true) {
				return 'main';
			}

			if (order.is_confirmed === false) {
				return 'danger';
			}
		}

		if (confirmedStatus === null) {
			return 'outlined';
		}

		if (confirmedStatus === true) {
			return 'main';
		}

		if (confirmedStatus === false) {
			return 'danger';
		}
	}, [confirmedStatus, order])

	const handleClick = async (event: React.SyntheticEvent) => {
		event?.stopPropagation();

		if (isVisitEnd) {
			return;
		}

		const newStatus = variant === 'outlined' ? true : variant === 'main' ? false : null;

		setConfirmedStatus(newStatus);

		await dispatch(editOrderConfirmed({ is_confirmed: newStatus, id: order.id })).then(async (res) => {
			if ((res.payload as unknown as Order)?.id) {
				dispatch(updateOrderDetail(res.payload as unknown as Order));

        // const dt_start = (res.payload as unknown as Order).dt_start
        // await dispatch(updateOrderGroupItemMhz({
        //   id: order.id,
        //   updates: {
        //     dt_start,
        //     is_confirmed: newStatus
        //   }
        // }))
			}
		})

    setTimeout(() => {
      callback?.(order.id);
    }, 0);
	}

	useEffect(() => {
		if (orderDetails?.id === order.id) {
			if (isVisitEnd) {
				return;
			}

			setConfirmedStatus(orderBooking?.is_confirmed)
		}
		// eslint-disable-next-line
	}, [orderBooking]);

	return (
		<ConfirmOrderButtonWrapper>
			<ConfirmOrderButton className="confirm-order"
				$variant={variant as TColorText}
				onClick={!window.matchMedia("(pointer: coarse)").matches ? handleClick : undefined}
				onTouchStart={handleClick}
				mode={mode}
			>
				{variant === 'outlined' && <Img src={checkIcon} />}
				{variant === 'main' && <Img src={checkWhiteIcon} />}
				{variant === 'danger' && <Img src={closeWhiteIcon} />}
			</ConfirmOrderButton>
		</ConfirmOrderButtonWrapper>
	);
};
